import type { ReactNode } from 'react'

interface AdminSectionCardProps {
  id: string
  title: string
  children: ReactNode
  className?: string
}

export function AdminSectionCard({ id, title, children, className = '' }: AdminSectionCardProps) {
  return (
    <section
      id={id}
      className={`rounded-lg p-6 border-2 ${className}`}
      style={{ borderColor: 'var(--bg-tertiary)', backgroundColor: 'var(--bg-secondary)' }}
      aria-labelledby={`${id}-heading`}
    >
      <h2 id={`${id}-heading`} className="text-xl font-semibold mb-3" style={{ color: 'var(--text-primary)' }}>
        {title}
      </h2>
      {children}
    </section>
  )
}
